import { Outlet, useParams } from "react-router-dom";
import { useEffect } from "react";
import { setCountry } from "../service/http.localStorage";

const CountryLayout = () => {
  const { country } = useParams();

  useEffect(() => {
    if (country) {
      // Сохраняем выбранную страну
      setCountry(country);
    }
  }, [country]);

  return <Outlet />;
};

export default CountryLayout;
